import { render, staticRenderFns } from "./in-page-messages.vue?vue&type=template&id=c252c1b0"
import script from "./in-page-messages.vue?vue&type=script&lang=js"
export * from "./in-page-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports